import 'slick-carousel';
import 'intersection-observer';
import 'desvg';
import './utils/micromodal-polyfill';
import MicroModal from 'micromodal';
import scrollAnim from './class/scroll_anim';
import subSearch from './class/sub_search';
import showPw from './class/show_pw';
import nearHospital from './class/near_hospital';
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';


datepickerFactory($);
datepickerJAFactory($);

window.addEventListener('DOMContentLoaded', () => {
  new scrollAnim();
  new subSearch();
  new showPw();
});

window.addEventListener('load', function(){
  // deSVG('[src$=".svg"]', true);
});

getScript('https://ajaxzip3.github.io/ajaxzip3.js');
getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyAowWBc5E7_kWazuCPDLim-KdNBTcOavWE', function() {
  new nearHospital();
});

function getScript(source, callback) {
	var script = document.createElement('script');
	var prior = document.getElementsByTagName('script')[0];
	script.async = 1;

	script.onload = script.onreadystatechange = function( _, isAbort ) {
		if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
			script.onload = script.onreadystatechange = null;
			script = undefined;

			if(!isAbort) { if(callback) callback(); }
		}
	};

	script.src = source;
	prior.parentNode.insertBefore(script, prior);
}

// カレンダーピッカー
$(function() {
  $('#datepicker').datepicker({
    dateFormat: 'yy年 m月 d日',
    minDate: 0,
  });
  $.datepicker.regional['ja'];
});

// クリニック詳細のMVスライダー
$(function() {
  const slider = $('.phSlider_list').slick({
    autoplay: true, //自動再生
    autoplaySpeed: 5000, //自動再生時にスライドが静止している時間
    speed: 800, //スライドするスピード
    dots: true, //スライドしたのドット
    arrows: false, //左右の矢印
    infinite: true, //スライドループ
  });
  $('.tabHead_btn').on('click', function() {
    setTimeout(function(){
      slider.slick('setPosition');
    }, 1);
  });
});

// タブコンテンツ
$(function() {
  let tabBtn = '.tabHead_btn';
  let tabCont = '.tabBody_item';
  let activeClass = '-active';
  $(tabBtn).on('click', function() {
    $(tabBtn).removeClass(activeClass);
    $(this).addClass(activeClass);
    const index = $(tabBtn).index(this) + 1;
    $(tabCont).removeClass(activeClass);
    $(tabCont + ':nth-child(' + index + ')').addClass(activeClass);
    window.location.hash = 'tab' + index;
  });

  // ハッシュを取得して表示するタブを切り替える
  var hash = location.hash;

  if(hash.length){
    var hashTab = (hash.match(/^#tab\d+/) || [])[0];
    var hashNum = (hash.match(/^#tab(\d+)/) || [])[1];
    if(!($(tabCont + ':nth-child(' + hashNum + ')').length)) {
      var hashNum = "1";
    }
    hashTabChange();
  } else{
    if(!$(tabBtn).hasClass(activeClass)) {
      var hashNum = "1";
      hashTabChange();
    }
  }
  // console.log('hash:'+hash);
  // console.log('hashTab:'+hashTab);
  // console.log('hashNum:'+hashNum);

  function hashTabChange() {
    $(tabCont).removeClass(activeClass);
    $(tabBtn).removeClass(activeClass);

    $(tabCont + ':nth-child(' + hashNum + ')').addClass(activeClass);
    $(tabBtn + ':nth-child(' + hashNum + ')').addClass(activeClass);
  }
});

// 同意ボタンチェックでフォーム送信可
$(function() {
  const checkAgree = $('#form-agree');
  const btnSubmit = $('#form-submit');

  checkAgree.on('click', function() {
      if ($(this).prop('checked') == false) {
          btnSubmit.prop('disabled', true);
      } else {
          btnSubmit.prop('disabled', false);
      }
  });
});

// モーダル
MicroModal.init({
  disableScroll: true, // 背景スクロール禁止
});

$(function() {
  $('.dl-accordion_btn').on('click', e => {
    const _this = $(e.currentTarget);
    _this.toggleClass('-open');
    _this.next('.dl-accordion_cont').stop().slideToggle(1000);
    return false;
  });
});
